import {
  type UserTourState,
  type UserTourStateActions,
  UserTourStateDefault,
  reducer,
  userTourStateActions,
} from "@/features/tour/reducer";
import { useCompletedTour } from "@/features/tour/utils";
import { useSettings } from "@repo/ui";
import { useTypesafeActions } from "@repo/utils";
import { type PropsWithChildren, createContext, useContext } from "react";

import { ProjectOverviewTour } from "./ProjectTour";

const UserTourContext = createContext<UserTourState>({} as UserTourState);

export const ProjectTourProvider = ({ children }: PropsWithChildren) => {
  const { tourData, isValidating } = useCompletedTour(
    UserTourStateDefault.currentTour
  );
  const { feature_flags } = useSettings();
  const [state, actions] = useTypesafeActions<
    UserTourState,
    UserTourStateActions
  >(
    reducer,
    {
      ...UserTourStateDefault,
    },

    userTourStateActions
  );

  return (
    <UserTourContext.Provider value={state}>
      {!isValidating && feature_flags?.projects_intro && tourData && (
        <ProjectOverviewTour state={state} actions={actions} />
      )}
      {children}
    </UserTourContext.Provider>
  );
};

export const useProjectTour = () => useContext(UserTourContext);
